import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Shopify template tool", -1)
const _hoisted_3 = { class: "row left" }
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "forApp"
}, " Fomo Template ", -1)
const _hoisted_7 = {
  class: "form-control",
  ref: "fomo",
  type: "file"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 separator" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  action: "/form/Shopify/ProcessTemplates",
  enctype: "multipart/form-data",
  method: "post"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "forApp"
}, " Target Page Template ", -1)
const _hoisted_17 = {
  id: "pagetemplate",
  name: "pagetemplate",
  ref: "targetpage",
  class: "form-select"
}
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "forApp"
}, "Store Template", -1)
const _hoisted_21 = {
  class: "form-control",
  ref: "store",
  id: "file",
  name: "file",
  type: "file"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary",
    type: "submit",
    name: "submit"
  }, " Process ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("input", _hoisted_7, null, 512)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadFomo && _ctx.uploadFomo(...args))),
          disabled: _ctx.templatePages.length > 0
        }, " Upload ", 8, _hoisted_8)
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      (_ctx.templatePages.length > 0)
        ? (_openBlock(), _createElementBlock("form", _hoisted_12, [
            _createElementVNode("input", {
              type: "hidden",
              value: _ctx.sessionId,
              id: "session",
              name: "session"
            }, null, 8, _hoisted_13),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("select", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatePages, (o, i) => {
                    return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(o), 1))
                  }), 128))
                ], 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("input", _hoisted_21, null, 512)
              ])
            ]),
            _hoisted_22
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}